import { Tooltip } from '@mui/material';
import type { ReactElement } from 'react';
import DisabledHint from '~/components/Tooltips/DisabledHint';

/**
 * Hint around an open-in-viewer button. Disabled needs `DisabledHint`: a
 * disabled button is not focusable, so without its focusable span the hint
 * would be pointer-only.
 */
export default function OpenButtonHint({
    enabled,
    title,
    children,
}: {
    enabled: boolean;
    title: string;
    children: ReactElement;
}) {
    return enabled ? (
        <Tooltip describeChild title={title} placement="left">
            {children}
        </Tooltip>
    ) : (
        <DisabledHint title={title} placement="left">
            {children}
        </DisabledHint>
    );
}
